export default __webpack_public_path__ + "d02fa5e756d02f2801bf8c6d485edd5e.png";